module.exports = __webpack_public_path__ + "img/wx-code.606f988c.png";